<template>
  <div class="spl-item-migration-error-list">
    <!-- THE MINIMIZED HEADER SHOWING NUMBER OF EXCEPTIONS -->
    <div
      v-if="errors.length > 0"
      class="spl-item-migration-error-list__nav-button"
      @click="toggle_Minimized">
      <div>
        <span class="spl-monitor-text-header">Exceptions</span>
        <br>
        <span class="spl-monitor-text-red">{{ errors.length }} Pending</span>
      </div>
    </div>

    <!-- EXCEPTIONS LIST -->
    <div
      :class="{'spl-message-modal-holder-show': !minimized}"
      class="spl-monitor-modal-holder"
      @click.self="toggle_Minimized">
      <div class="spl-monitor-modal">
        <h1>ITEM MIGRATION EXCEPTION LIST</h1>
        <table class="spl-monitor-table">
          <tr @click="toggle_Minimized">
            <th>timestamp</th>
            <th>function name</th>
            <th>exception message</th>
            <th>item json</th>
          </tr>

          <tr
            v-for="(migrationError, index) in errors"
            :key="index"
            class="spl-table-parcel-list__row"
            @click="show_Item_Json(migrationError.Item)">
            <td>{{ migrationError.Log_Timestamp }}</td>
            <td>{{ migrationError.Calling_Function }}</td>
            <td>{{ migrationError.Exception_Message }}</td>
            <td>{{ truncate_Item_JSON(migrationError) }}</td>
          </tr>
        </table>
      </div>

      <!-- ITEM DETAILS -->
      <div
        :class="{'spl-message-modal-holder-show': show_item_json}"
        class="spl-monitor-modal-holder"
        @click.self="hide_Item_Json">
        <div class="spl-monitor-modal">
          <h1>ITEM JSON</h1>
          <vue-json-pretty
            v-if="show_item_json"
            selectable-type="tree"
            :deep="3"
            :data="item_json" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VueJsonPretty from 'vue-json-pretty'

export default {
  name: 'ItemMigrationErrorList',
  components: {
    VueJsonPretty
  },

  data () {
    return {
      exception_list: [],
      item_json: {},
      minimized: true,
      show_item_json: false
    }
  },
  computed: {
    ...mapState('migrationErrors', ['errors'])
  },
  methods: {
    // Change between seeing the exception list (or Item JSON) and not.
    toggle_Minimized () {
      this.minimized = !this.minimized
    },
    // Show Item JSON modal window
    show_Item_Json (json) {
      if (json) {
        this.item_json = json
        this.show_item_json = true
      }
    },
    // Hide Item JSON modal window
    hide_Item_Json () {
      this.show_item_json = false
    },

    truncate_Item_JSON (exceptionRow) {
      var itemJsonText = ''
      if (exceptionRow.Item_JSON && exceptionRow.Item_JSON !== '') {
        itemJsonText = exceptionRow.Item_JSON.substring(0, 30) + '...'
      }
      return itemJsonText
    }
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";
.spl-item-migration-error-list {
  &__nav-button {
    height: 100px;
    margin-left: -34px;
    margin-top: -20px;
    & div {
      padding-left: 34px;
      padding-top: 20px;
    }
  }
  padding-left: 15px;
}
.spl-monitor-text-header {
  height: 200px;
  overflow: hidden;
  color: $headerLatestUpdatesLabelColor;
  font-size: 9px;
  font-weight: 600;
}
.spl-monitor-text-red {
  font-family: $mono;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 12px;
  letter-spacing: 1px;
  color: $red;
}
.spl-monitor-table {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}
.spl-message-modal-holder-show {
  display: auto !important;
}
.spl-monitor-modal-holder {
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 9000;
  overflow: auto;

  &-show {
    display: block;
  }
  .spl-monitor-modal {
    left: 10%;
    padding: 20px 15px 30px 15px;
    position: absolute;
    top: 10%;
    transform: translate3d(-10px, 0, 0);
    width: 80%;
    color: $parcelDetailBlockLabelColor;
    background-color: $lightYellow;

    @include mobile() {
      left: $mobilePadding;
      transform: translate3d(0, 0, 0);
      top: $mobilePadding;
      width: calc(100% - #{$mobilePadding * 2});
    }
    &__close {
      background-image: url(../../assets/icon-close.svg);
      background-position: center center;
      background-repeat: no-repeat;
      cursor: pointer;
      height: 25px;
      position: absolute;
      right: 10px;
      top: 20px;
      transition: opacity $shortTransition ease-in-out;
      width: 25px;

      &:hover {
        opacity: 0.5;
      }
    }
  }
}
</style>
